/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_which_aoe = function (altNode, actor, battleState) {
  const node = new TreeNode(actor, battleState);

  node.altNode = altNode;

  // branch indexes
  node.DEVIL_MASK = 0;
  node.ICE_NINE = 1;
  node.SKY_HAMMER = 2;

  node.devilMask = BattleCalc.getEquippedAbility(actor, 'devil_mask');
  node.iceNine = BattleCalc.getEquippedAbility(actor, 'ice_nine');
  node.skyHammer = BattleCalc.getEquippedAbility(actor, 'sky_hammer');

  if (node.devilMask) {
    node.branches[node.DEVIL_MASK] = new UseAbility(actor, 'devil_mask', actor);
  }

  if (node.iceNine) {
    node.branches[node.ICE_NINE] = new UseAbility(actor, 'ice_nine');
  }

  if (node.skyHammer) {
    node.branches[node.SKY_HAMMER] = new UseAbility(actor, 'sky_hammer');
  }

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.devilMask = null;
    node.iceNine = null;
    node.skyHammer = null;
    originalDispose.call(node);
  };

  node.query = function (target) {
    if (
      node.devilMask &&
      !BattleCalc.getCondition(target, 'scared') &&
      !BattleCalc.getCondition(target, 'unshakeable') &&
      BattleCalc.boardDistance(actor, target) <= node.devilMask.effectRange
    ) {
      return node.branches[node.DEVIL_MASK].query();
    } else if (
      node.skyHammer &&
      BattleCalc.boardDistance(actor, target) <= node.skyHammer.effectRange + 1
    ) {
      const adjacentTiles = node.battleState.getAdjacentTiles(target);
      return node.branches[node.SKY_HAMMER].query(
        adjacentTiles[Math.floor(Math.random() * adjacentTiles.length)]
      );
    } else if (
      node.iceNine &&
      !BattleCalc.getCondition(target, 'slowed') &&
      !BattleCalc.getCondition(target, 'liberated')
    ) {
      return node.branches[node.ICE_NINE].query(target);
    } else {
      return node.altNode.query(target);
    }
  };

  return node;
};
module.exports = Q_which_aoe;
